module.exports = __webpack_public_path__ + "36b20a677fb6fc0793341af1cf0437c9.svg";